import { PageEnum } from '@/enums/pageEnum'
const Layout = () => import('@/components/layout/index.vue')

// 根路由
export const RootRoute = {
  path: '/',
  name: 'Root',
  redirect: PageEnum.BASE_HOME,
  meta: {
    title: 'Root'
  }
}

// 登录页面
export const LoginRoute = {
  path: '/login',
  name: 'Login',
  component: () => import('@/views/login/Login.vue'),
  meta: {
    title: '登录'
  }
}

// 网路错误页面
export const NetworkErrorRoute = {
  path: '/network-error',
  name: 'NetworkError',
  meta: {
    title: 'Network Error'
  },
  component: () => import('@/views/errors/NetworkError.vue')
}

// 404错误提示页面
export const ErrorPage403Route = {
  path: '/403',
  name: PageEnum.ERROR_PAGE_NAME + '403',
  component: Layout,
  meta: {
    title: 'Error Page 403'
  },
  children: [
    {
      path: '',
      name: 'ErrorPage403',
      component: () => import('@/views/errors/403.vue'),
      meta: {
        title: 'Error Page 403'
      }
    }
  ]
}

// 404错误提示页面
export const ErrorPageRoute = {
  path: '/:path(.*)*',
  name: PageEnum.ERROR_PAGE_NAME,
  component: Layout,
  meta: {
    title: 'ErrorPage'
  },
  children: [
    {
      path: '/:path(.*)*',
      name: 'ErrorPageSon',
      component: () => import('@/views/errors/404.vue'),
      meta: {
        title: 'ErrorPage'
      }
    }
  ]
}
